// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2tFHu","col":"Table_col__3LBYZ","fulfillmentStatus":"Table_fulfillmentStatus__16S6O","emailCol":"Table_emailCol__3t19F"};